<template>
  <div class="content">
    <PageHeader title="Congratulations"></PageHeader>
    <h3>Step 1 complete</h3>
    <v-card
      outlined
      class="mb-4 vcardcontent"
      v-if="!overlay"
    >
      <v-list-item>
        <v-list-item-content>
        <v-card-text style="color:#ffffff;" class="honeyBold">
          <p>
          After the match, Fanhive will notify you to complete Step 2 by selecting the Nantwich FC Fans Player of the Match and to optionally rate the Nantwich FC players.
          </p>
          <p>
          The more you participate, the more Fanhive honey points you earn.
          </p>
        </v-card-text>
        <EntryButtons v-if="entry" :entry="entry"></EntryButtons>
        <v-container>
          <v-row>
            <v-col>
              <router-link :to="{name: 'entry-home', query: {entryId: entry.id}}">Go to entry home</router-link>
            </v-col>
          </v-row>
        </v-container>
      </v-list-item-content>
    </v-list-item>
    </v-card>
    <v-overlay
      :absolute="false"
      :value="overlay"
      :opacity="0.9"
      >
      <v-progress-circular
        indeterminate
        color="amber"
        :size="70"
        :width="7"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import PageHeader from './../../components/PageHeader';
import EntryButtons from './EntryButtons.vue';

export default {
  name: 'entered',
  components: {
    PageHeader,
    EntryButtons
  },
  data: () => ({
    entry: null,
    overlay: false
  }),
  computed: {
    updatingEntry () {
      return this.$store.getters.updatingEntry;
    }
  },
  methods: {
    getEntry: function () {
      var scope = this;
      this.overlay = true;
      this.$store.dispatch('getEntry', this.$route.query.entryId).then(getEntryResponse => {
        scope.entry = getEntryResponse;
        scope.overlay = false;
      }, error => {
          scope.overlay = false;
          console.log(error);
      });
    }
  },
  created () {
    this.overlay = true;
    if(this.updatingEntry === 2) {
      this.getEntry();
    }
  },
  watch: {
    updatingEntry (newVal) {
      if(newVal === 2){
        this.getEntry();
      }
    }
  }
}
</script>